import { render, staticRenderFns } from "./DailyFerryEdit.vue?vue&type=template&id=1df6763b&scoped=true"
import script from "@/controllers/custom/daily_ferry/daily-ferry-edit.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/daily_ferry/daily-ferry-edit.js?vue&type=script&lang=js&external"
import style0 from "@/assets/css/custom/daily-ferry-edit.css?vue&type=style&index=0&id=1df6763b&prod&scoped=true&lang=css&external"
import style1 from "./DailyFerryEdit.vue?vue&type=style&index=1&id=1df6763b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df6763b",
  null
  
)

export default component.exports